import React from 'react';
import { CustomComponentsProps } from '@website-editor/customComponents';
import { PhotoGalleryAddEdit } from './pages/PhotoGalleryAddEdit';
import { PHOTO_GALLERY_ACTIONS } from './PhotoGallery.constants';

interface PhotoGalleryNavigationsProps extends CustomComponentsProps {}

export const getPhotoGalleryNavigations = (props: PhotoGalleryNavigationsProps) => {
  const photoGalleryAdd = (
    <PhotoGalleryAddEdit
      type={PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_ADD}
      {...props}
    />
  );
  const photoGalleryEdit = (
    <PhotoGalleryAddEdit
      type={PHOTO_GALLERY_ACTIONS.PHOTO_GALLERY_EDIT}
      {...props}
      isEditMode
    />
  );
  return [photoGalleryAdd, photoGalleryEdit];
};
